import { createApp } from 'vue';
import App from './App.vue'
import router from './router'

import '@/assets/sass/common.scss'

// 引入Vue国际化翻译
import i18n from '@/i18n/i18n'
import { createPinia } from 'pinia';

const app = createApp(App);
const pinia = createPinia();
app.use(pinia);
app.use(router);
app.use(i18n);
app.mount('#app');
